import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Exam-Schedule</h1>
                <p>Home &gt;  Exam-Schedule</p>
            </div>
        </div>
    )
}

export default Hero;